import { formatNumberWithComma } from "@/utils";

export const currentSavingsGraphOptions = ({ getChartYAxisLabel }) => ({
	title: { display: false },
	legend: { display: false },
	tooltips: {
		callbacks: {
			label: function (tooltipItem) {
				return formatNumberWithComma(Number(tooltipItem.value), 2);
			},
		},
	},
	responsive: true,
	maintainAspectRatio: false,
	scales: {
		xAxes: [
			{
				gridLines: { color: "rgba(0, 0, 0, 0)" },
				stacked: false,
				ticks: { fontFamily: "Nunito Sans" },
			},
		],
		yAxes: [
			{
				ticks: {
					maxTicksLimit: 6,
					fontFamily: "Nunito Sans",
					callback: (value) => getChartYAxisLabel(value),
				},
				stacked: false,
			},
		],
	},
});
